import { TOAST } from "sharedConstants"

export const showToast = (message, type = TOAST.TYPE.SUCCESS, route = "") => dispatch => {
  dispatch({
    type: TOAST.ACTION.SHOW,
    payload: { message, type, route }
  })
}
